/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Grid } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { updateTilesetStyle } from "../../functions/updateTilesetStyle";
import { Custom3DTileset } from "../../types/CesiumMapItems";
import AdjustmentSlider from "./AdjustmentSlider";

interface Props {
  tilesets: Custom3DTileset[];
  onPointSizeSettingsChange: (val: string) => void;
}

export type PointSizeSettings = {
  pointSize: number;
};

const PointSizeAdjustment = ({
  tilesets,
  onPointSizeSettingsChange,
}: Props): JSX.Element => {
  const { t } = useTranslation("cesium");
  const [pointSize, setPointSize] = useState<number>();
  const [changed, setChanged] = useState(false);

  useEffect(() => {
    const ps = tilesets[0].style?.style?.pointSize;
    if (!ps) return;
    if (
      (typeof ps === "string" || typeof ps === "number") &&
      !Number.isNaN(+ps)
    ) {
      setPointSize(+ps);
    }
  }, [changed, tilesets]);

  const handlePointSizeChange = useCallback(
    (val: number) => {
      if (!tilesets.length) return;
      tilesets.forEach((tileset) => {
        updateTilesetStyle({
          tileset,
          type: "pointSize",
          newValue: val,
        });
      });
      setChanged((prev) => !prev);
    },
    [tilesets],
  );

  React.useEffect(() => {
    if (!pointSize) return;
    const settings: PointSizeSettings = {
      pointSize,
    };
    const string = JSON.stringify(settings);
    onPointSizeSettingsChange(string);
  }, [pointSize, onPointSizeSettingsChange]);

  return (
    <Grid item xs={12}>
      <AdjustmentSlider
        value={pointSize}
        onChange={handlePointSizeChange}
        title={t("point-size")}
        step={1}
        min={1}
        max={15}
      />
    </Grid>
  );
};

export default PointSizeAdjustment;
